<template>
  <div ref="root" class="flex flex-col gap-32 md:flex-row md:gap-56">
    <div class="shrink-0">
      <RevIllustration
        alt=""
        class="rounded-lg max-md:w-full"
        :height="252"
        sizes="448px"
        src="/img/product/jp/aboutus.png"
        :width="448"
      />
    </div>

    <div>
      <h2 class="heading-2 mb-24">
        {{ i18n(translations.title) }}
      </h2>
      <p class="text-static-default-low body-1 mb-32">
        {{ i18n(translations.description) }}
      </p>
      <RevButton :to="{ name: CMS.ABOUT_US }" variant="secondary">
        {{ i18n(translations.more) }}
      </RevButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onUnmounted, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'
import { useIntersectionObserver } from '@vueuse/core'

import { CMS } from '~/scopes/cms/routes-names'

import translations from './ReassuranceAboutUs.translations'

const i18n = useI18n()
const { trackProductBlockImpression } = useTracking()
const root = ref<HTMLElement | null>()

const { stop } = useIntersectionObserver(root, ([{ isIntersecting }]) => {
  if (isIntersecting) {
    trackProductBlockImpression({
      block_name: 'reassurance_aboutus_block',
    })
  }
})

onUnmounted(() => {
  stop()
})
</script>
